export default __webpack_public_path__ + "static/media/PD8000.8fb711bc.png";